import { tryOnScopeDispose } from '@vueuse/core';

function useTimeout() {
  let timeoutHandle;
  const registerTimeout = (fn, delay) => {
    cancelTimeout();
    timeoutHandle = (typeof window!=="undefined"?window:globalThis).setTimeout(fn, delay);
  };
  const cancelTimeout = () => (typeof window!=="undefined"?window:globalThis).clearTimeout(timeoutHandle);
  tryOnScopeDispose(() => cancelTimeout());
  return {
    registerTimeout,
    cancelTimeout
  };
}

export { useTimeout };
//# sourceMappingURL=index.mjs.map
